<template>
  <div id="app">
    <NavBar />
    <RouterView :key="$route.path" />
    <FooterSection />
    <BannerSection />
    <CustomNotification />
  </div>
</template>

<script setup>
import NavBar from "@/components/NavBar.vue";
import FooterSection from "@/components/FooterSection.vue";
import BannerSection from "@/components/BannerSection.vue";
import CustomNotification from "@/components/CustomNotification.vue";
</script>

<style lang="scss">
@import "@/assets/css/settings.scss";

#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: $background-gray;
}

.main-content {
  padding: 0 1rem;
}
</style>
